module.exports = __webpack_public_path__ + "img/process-execution.48a25a31.jpg";